var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgJobs = function SvgJobs(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1663 5.22075V7.69575C20.1663 9.75825 19.3413 10.5833 17.2788 10.5833H14.8038C12.7413 10.5833 11.9163 9.75825 11.9163 7.69575V5.22075C11.9163 3.15825 12.7413 2.33325 14.8038 2.33325H17.2788C19.3413 2.33325 20.1663 3.15825 20.1663 5.22075ZM10.083 15.3041V17.7791C10.083 19.8416 9.25801 20.6666 7.19551 20.6666H4.72051C2.65801 20.6666 1.83301 19.8416 1.83301 17.7791V15.3041C1.83301 13.2416 2.65801 12.4166 4.72051 12.4166H7.19551C9.25801 12.4166 10.083 13.2416 10.083 15.3041Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9317 10.5834V12.985C15.9317 15.4509 14.9509 16.4317 12.485 16.4317H10.0834V15.3042C10.0834 13.2417 9.25836 12.4167 7.19586 12.4167H6.06836V10.015C6.06836 7.54919 7.04919 6.56836 9.51503 6.56836H11.9167V7.69586C11.9167 9.75836 12.7417 10.5834 14.8042 10.5834H15.9317Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jobs.175cbe6a.svg";
export { ForwardRef as ReactComponent };